// The client's front door. It mounts one component and gets out of the way.

import { render } from "preact";
import { App } from "./ui/app";

const root = document.getElementById("app");
if (!root) throw new Error("missing #app");

// The Turnstile site key is stamped into the document by the Worker, so the
// page and the server can never disagree about which gate this is.
render(<App siteKey={root.dataset.sitekey ?? ""} />, root);
